import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import FacultyMap from "./FacultyMap";
import UniMap from "./UniMap";
import Consts from "../Constants/AppConsts.json";
import NotFoundScreen from "./NotFoundScreen";
import { removeDomain } from "../Utils";

export default class App extends Component {
  constructor() {
    super();
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      this.Path = removeDomain("http://localhost:3000");
    } else {
      this.Path = process.env.PUBLIC_URL;
    }
  }
  render() {
    return (
      <Router basename="/virtualtour">
        <div>
          <Switch>
            <Route exact path="/">
              <UniMap key="01" currentPath={this.Path} typeSelectorOn />
            </Route>
            <Route exact path={`${this.Path}/2021/university/explore`}>
              <UniMap key="02" currentPath={this.Path} />
            </Route>
            <Route
              exact
              path={`${this.Path}/2021/faculty/explore/floor/basement`}
            >
              <FacultyMap
                currentPath={this.Path}
                headerText={Consts.floor.basement}
                floor="basement"
              />
            </Route>
            <Route
              exact
              path={`${this.Path}/2021/faculty/explore/floor/ground`}
            >
              <FacultyMap
                currentPath={this.Path}
                headerText={Consts.floor.ground}
                floor="ground"
              />
            </Route>
            <Route exact path={`${this.Path}/2021/faculty/explore/floor/first`}>
              <FacultyMap
                currentPath={this.Path}
                headerText={Consts.floor.first}
                floor="first"
              />
            </Route>
            <Route
              exact
              path={`${this.Path}/2021/faculty/explore/floor/second`}
            >
              <FacultyMap
                currentPath={this.Path}
                headerText={Consts.floor.second}
                floor="second"
              />
            </Route>
            <Route
              render={props => (
                <NotFoundScreen {...props} currentPath={`${this.Path}`} />
              )}
            />
          </Switch>
        </div>
      </Router>
    );
  }
}
